module.exports = "/images/x-circle 1.svg";